<script>
	import { onMount } from "svelte";
	let recentPayouts = [];

	async function fetchRecentPayouts() {
		try {
			const response = await fetch("/api/recent_payouts");
			recentPayouts = await response.json();
		} catch (error) {
			// Handle the API call failure here
			console.error("API call failed:", error);

			// Generate some fake payouts for the table
			recentPayouts = [
				{
					game: "Sand Casino Sim",
					user: "Ben Airo",
					time: "12:30",
					type: "OSRS",
					bet: "20M",
					multiplier: "4",
					payout: "80M",
				},
				{
					game: "Alkharid Slots",
					user: "Bigdickswinging",
					time: "12:45",
					type: "OSRS",
					bet: "10",
					multiplier: "0.00",
					payout: undefined,
				},
				{
					game: "Life",
					user: "Tyluur",
					time: "12:45",
					type: "OSRS",
					bet: "10",
					multiplier: "0.00",
					payout: undefined,
				},
				{
					game: "Sand Casino Sim",
					user: "Ben Airo",
					time: "12:30",
					type: "OSRS",
					bet: "10M",
					multiplier: "10.05",
					payout: "100.5M",
				},
				// Add more fake payouts as needed
			];
		}
	}

	onMount(fetchRecentPayouts);

	// Dummy data for the games section
	let games = [];

	games.push({ name: "Dice" });
	games.push({ name: "Crash" });
	games.push({ name: "Sports" });
	games.push({ name: "Blackjack" });
	games.push({ name: "Baccarat" });
	games.push({ name: "War" });
	games.push({ name: "Roulette" });
	games.push({ name: "Keno" });
	games.push({ name: "Hilo" });
	games.push({ name: "Wheel" });
	games.push({ name: "Mines" });
	games.push({ name: "Limbo" });
	games.push({ name: "Video Poker" });
	games.push({ name: "Slots" });
	games.push({ name: "Magic Slots" });
	games.push({ name: "Flower Poker" });
	games.push({ name: "Plinko" });
	games.push({ name: "Coin Flip" });
	games.push({ name: "Goal" });
	games.push({ name: "Multi Hilo" });
	games.push({ name: "Multi Blackjack" });
	games.push({ name: "Scratch Card" });
</script>

<div class="grid-container">
	<div class="toolbar">
		<div class="logo">
			<img src="logo.png" alt="Logo" />
			<div class="logo-text">
				<div class="large-text">GP Casino</div>
				<div class="small-text">RS3 0.022 OSRS 0.23</div>
			</div>
		</div>
		<div class="buttons">
			<button class="btn btn-green">Deposit</button>
			<button class="btn btn-red">Withdraw</button>
			<button class="btn btn-dark">Login</button>
		</div>
	</div>

	<div class="advert">
		<!-- Advertisement content goes here -->
		<img src="/ad-banner.png" />
	</div>

	<div class="games">
		<!-- Game icons (6x4 grid) -->
		{#each games as game}
			<div class="game">
				<div class="game-background">
					<img
						src="/games/backgrounds/{game.name
							.toLowerCase()
							.replace(' ', '-')}-background.png"
						alt="game-backgound"
					/>
				</div>
				<div class="game-overlay">
					<img
						src="/games/overlays/{game.name
							.toLowerCase()
							.replace(' ', '-')}-overlay.png"
						alt="game-backgound"
					/>
				</div>
				<span>{game.name}</span>
			</div>
		{/each}
	</div>

	<table class="payout-table">
		<!-- Payout table headers -->
		<thead>
			<tr>
				<th>Game</th>
				<th>User</th>
				<th>Time</th>
				<th>Bet</th>
				<th>Multiplier</th>
				<th>Payout</th>
			</tr>
		</thead>
		<tbody>
			<!-- Dynamic content for the payout table -->
			{#each recentPayouts as payout}
				<tr>
					<td class="payout-game">{payout.game}</td>
					<td class="payout-user">{payout.user}</td>
					<td>{payout.time}</td>
					<td>{payout.bet} {payout.type}</td>
					<td>{payout.multiplier}x</td>
					{#if payout.payout}
						<td class="payout-win">{payout.payout} {payout.type}</td
						>
					{:else}
						<td>0 {payout.type}</td>
					{/if}
				</tr>
			{/each}
		</tbody>
	</table>

	<div class="footer" />
</div>
